import type { AnalysisStep } from '../../types';

export const STEP_LABELS: Record<AnalysisStep, string> = {
  NORMALIZE: 'Нормализация',
  CHUNK: 'Разбивка на части',
  ANALYZE_CHUNKS: 'Анализ частей',
  AGGREGATE: 'Объединение результатов',
  SUMMARIZE: 'Формирование итогов',
  DONE: 'Готово',
  FAILED: 'Ошибка',
};

export const STAGE_LABELS: Record<string, string> = {
  intro: 'Знакомство',
  qualification: 'Квалификация',
  negotiation: 'Переговоры',
  waiting: 'Ожидание',
  conflict: 'Конфликт',
  closed: 'Закрыто',
  unknown: 'Неизвестно',
};

export const OWNER_LABELS: Record<string, string> = {
  us: 'Мы',
  client: 'Клиент',
  unknown: 'Неизвестно',
};

export const RISK_SEVERITY_COLORS: Record<string, string> = {
  low: 'bg-accent-warning/20 text-accent-warning',
  medium: 'bg-accent-warning/20 text-accent-warning',
  high: 'bg-accent-danger/20 text-accent-danger',
};

export const DISCUSSED_TYPE_LABELS: Record<string, string> = {
  agreement: 'Договорённость',
  decision: 'Решение',
  info: 'Информация',
};

export function formatTimestamp(ts: string): string {
  try {
    const date = new Date(ts);
    return date.toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return ts;
  }
}
